import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ProductoConsultaApi {
    id: number;
    tipoProductoId: number;
    numeroRegistroIca: string;
    nombreComercial: string;
    casaProductora: string;
    OrigenDelProducto?: string;
    origenDelProducto?: string;
    subgrupoId?: number | null;
    funcionEspecificaId?: number | null;
    funcionQuimicaId?: number | null;
    composicionId?: number | null;
    nombreComunId?: number | null;
    estadoValidacion?: string | null;
    alimentoBalanceadoParaAnimales?: Array<{
        especieId?: number | null;
        etapaProductiva?: string | null;
        especie?: { id: number; nombre: string };
        etapaProductivaCatalogo?: { id: number; nombre: string };
    }>;
    presentaciones?: Array<{
        cantidad?: number;
        empaqueUnidadMedida?: {
            empaque?: { nombre?: string };
            unidadMedida?: { nombre?: string; abreviacion?: string };
        };
    }>;
}

export type ProductoConsultaFiltros = Record<string, string | number>;

export interface ProductoConsultaPayload {
    filter?: ProductoConsultaFiltros;
    page?: number;
    pageSize?: number;
}

export interface ProductoConsultaPaginatedResponse {
    data: ProductoConsultaApi[];
    total: number;
    page: number;
    pageSize: number;
}

@Injectable({
    providedIn: 'root',
})
export class ProductoConsultaService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getProductos(
        payload: ProductoConsultaPayload = {}
    ): Observable<ProductoConsultaPaginatedResponse> {
        return this.http.post<ProductoConsultaPaginatedResponse>(
            `${this._apiUrl}producto/consultar`,
            payload
        );
    }
}
